import React, { useState, useEffect } from 'react';
import { useAppContext } from '../../contexts/AppContext';
import SyncButton from './SyncButton';
import styles from './index.module.scss';

const NotificationCenter = () => {
  const {
    notifications,
    removeNotification,
    clearAllNotifications,
    markNotificationAsRead,
    markAllNotificationsAsRead,
    isChatVisible
  } = useAppContext();
  const [isOpen, setIsOpen] = useState(false);

  const getNotificationIcon = (type) => {
    switch (type) {
      case 'success': return '✅';
      case 'error': return '❌';
      case 'warning': return '⚠️';
      case 'info': return 'ℹ️';
      default: return 'ℹ️';
    }
  };

  const getNotificationClass = (type) => {
    switch (type) {
      case 'success': return styles.success;
      case 'error': return styles.error;
      case 'warning': return styles.warning;
      case 'info': return styles.info;
      default: return styles.info;
    }
  };

  const formatTime = (timestamp) => {
    const date = new Date(timestamp);
    const now = new Date();
    const diffMs = now - date;
    const diffMins = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMs / 3600000);
    const diffDays = Math.floor(diffMs / 86400000);

    if (diffMins < 1) return '刚刚';
    if (diffMins < 60) return `${diffMins}分钟前`;
    if (diffHours < 24) return `${diffHours}小时前`;
    if (diffDays < 7) return `${diffDays}天前`;
    return date.toLocaleDateString('zh-CN');
  };

  const unreadCount = notifications.filter(n => !n.isRead).length;

  const handleToggle = () => {
    setIsOpen(!isOpen);
    if (!isOpen && unreadCount > 0) {
      // 打开面板时批量标记所有通知为已读
      markAllNotificationsAsRead();
    }
  };

  // 在移动端，当聊天对话框打开时自动关闭通知面板
  useEffect(() => {
    if (isChatVisible && window.innerWidth <= 768) {
      setIsOpen(false);
    }
  }, [isChatVisible]);

  return (
    <div className={`${styles.notificationCenter} ${isChatVisible ? styles.chatDialogOpen : ''}`}>
      {/* 通知按钮 */}
      <button
        className={`${styles.notificationButton} ${unreadCount > 0 ? styles.hasUnread : ''}`}
        onClick={handleToggle}
      >
        🔔
        {unreadCount > 0 && (
          <span className={styles.badge}>{unreadCount > 99 ? '99+' : unreadCount}</span>
        )}
      </button>

      {/* 通知面板 */}
      {isOpen && (
        <div className={styles.notificationPanel}>
          <div className={styles.panelHeader}>
            <h3>通知中心</h3>
            <div className={styles.headerActions}>
              <SyncButton />
              {notifications.length > 0 && (
                <button
                  className={styles.clearAllButton}
                  onClick={clearAllNotifications}
                >
                  清空全部
                </button>
              )}
              <button
                className={styles.closeButton}
                onClick={() => setIsOpen(false)}
              >
                ×
              </button>
            </div>
          </div>

          <div className={styles.notificationList}>
            {notifications.length === 0 ? (
              <div className={styles.emptyState}>
                <div className={styles.emptyIcon}>📭</div>
                <p>暂无通知</p>
              </div>
            ) : (
              notifications.map(notification => (
                <div
                  key={notification.id}
                  className={`${styles.notificationItem} ${getNotificationClass(notification.type)} ${!notification.isRead ? styles.unread : ''}`}
                >
                  <div className={styles.itemContent}>
                    <div className={styles.itemHeader}>
                      <span className={styles.icon}>
                        {getNotificationIcon(notification.type)}
                      </span>
                      <div className={styles.title}>{notification.title}</div>
                      <span className={styles.time}>{formatTime(notification.timestamp)}</span>
                    </div>
                    {notification.message && (
                      <div className={styles.message}>{notification.message}</div>
                    )}
                  </div>
                  <button
                    className={styles.removeButton}
                    onClick={() => removeNotification(notification.id)}
                    title="删除此通知"
                  >
                    ×
                  </button>
                </div>
              ))
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default NotificationCenter;
